import { render, staticRenderFns } from "./GeneralSettingsDateFormat.vue?vue&type=template&id=23a85a11&"
import script from "./GeneralSettingsDateFormat.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsDateFormat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports